import $ from 'jquery';
import TomSelect from 'tom-select';

const scoreByMatchingString = (search) => (item) => {
  const term = search.replace(/\s+/g, '').toLowerCase();
  const text = item.text.replace(/\s+/g, '').toLowerCase();
  return text.includes(term) ? 1 : 0;
};

const alreadyTomselected = (element) => {
  if (element.classList.contains('tomselected')) {
    console.debug('Element was already tomselected.');
    console.debug(element);

    return true;
  }

  return false;
};

const updateTomSelectState = (element) => {
  if (element.hasAttribute('disabled') && !element.tomselect.isDisabled) {
    element.tomselect.disable();
  } else if (!element.hasAttribute('disabled') && element.tomselect.isDisabled) {
    element.tomselect.enable();
  }
};

const observeTomSelectDisabledAttribute = (element) => {
  const observer = new MutationObserver(() => updateTomSelectState(element));
  observer.observe(element, { attributes: true, attributeFilter: ['disabled'] });
};

const setupTomSelect = (element) => {
  if (alreadyTomselected(element)) {
    return null;
  }

  const tomSelect = new TomSelect(element, {
    maxOptions: null,
    score: scoreByMatchingString
  });

  updateTomSelectState(element);
  observeTomSelectDisabledAttribute(element);

  return tomSelect;
};

const setupTomSelectTagging = (element) => {
  if (alreadyTomselected(element)) {
    return null;
  }

  const tomSelect = new TomSelect(element, {
    plugins: {
      remove_button: {}
    },
    create: true,
    delimiter: ',',
    hidePlaceholder: true,
    maxOptions: null,
    maxItems: null,
    scoreByMatchingString
  });

  updateTomSelectState(element);
  observeTomSelectDisabledAttribute(element);

  return tomSelect;
};

const setupTomSelectAjax = (element, url) => {
  const tomSelect = new TomSelect(element, {
    maxOptions: null,
    valueField: 'value',
    labelField: 'label',
    searchField: 'label',
    load(query, callback) {
      const headers = new Headers({
	'Content-Type': 'application/json',
	'X-Api-Version': '1'
      });

      const queryURL = `${url}?term=${encodeURIComponent(query)}`;

      fetch(queryURL, { headers })
	.then(response => response.json())
	.then(json => {
	  callback(json.data);
	}).catch((error) => {
	  console.debug(error);

	  callback();
	});
    }
  });

  updateTomSelectState(element);
  observeTomSelectDisabledAttribute(element);

  return tomSelect;
};

const setupRecurrenceRulesFormButtons = () => {
  const syncFareAdapterElementRowState = (row) => {
    const priceTypeField = row.querySelector('select[name*="[elements_attributes]"][name*="[price_type]"]');
    if (!priceTypeField) return;

    const isBasePrice = priceTypeField.value === 'base_price';
    const discountTypeField = row.querySelector('select[name*="[elements_attributes]"][name*="[discount_type]"]');
    const absoluteAmountField = row.querySelector('input[name*="[elements_attributes]"][name*="[absolute_amount]"]');
    const relativeAmountField = row.querySelector('input[name*="[elements_attributes]"][name*="[relative_amount]"]');

    if (discountTypeField) {
      discountTypeField.disabled = isBasePrice;
    }

    if (absoluteAmountField) {
      absoluteAmountField.disabled = !isBasePrice && discountTypeField?.value === 'relative';
    }

    if (relativeAmountField) {
      relativeAmountField.disabled = isBasePrice || discountTypeField?.value === 'absolute';
    }
  };

  $(document).ready(() => {
    document
      .querySelectorAll('tr')
      .forEach((row) => syncFareAdapterElementRowState(row));

    $('form').on('click', '.js-remove-row', (event) => {
      const row = event.target.closest('tr');
      if (!row) return;

      $(row).find('input.js-remove-flag').val('1');
      $(row).hide();

      event.preventDefault();
    });

    $('form').on('click', '.js-all-day', (event) => {
      const row = event.target.closest('tr');
      const fromOffset = row.querySelector('.js-valid-from-offset');
      const untilOffset = row.querySelector('.js-valid-until-offset');

      fromOffset.tomselect.setValue('0');
      untilOffset.tomselect.setValue('86400');

      event.preventDefault();
    });

    $('form').on('click', '.js-copy', (event) => {
      document.querySelector('.js-add-row').click();

      const copiedRow = event.target.closest('tr');
      const copiedRowDayOfWeek = copiedRow.querySelector('.js-day-of-week').tomselect;
      const copiedRowFromOffset = copiedRow.querySelector('.js-valid-from-offset').tomselect;
      const copiedRowUntilOffset = copiedRow.querySelector('.js-valid-until-offset').tomselect;

      const lastRow = document.getElementById('recurrence_rulesTable').querySelector('tr:last-of-type');
      const lastRowDayOfWeek = lastRow.querySelector('.js-day-of-week').tomselect;
      const lastRowFromOffset = lastRow.querySelector('.js-valid-from-offset').tomselect;
      const lastRowUntilOffset = lastRow.querySelector('.js-valid-until-offset').tomselect;

      lastRowDayOfWeek.setValue(copiedRowDayOfWeek.getValue());
      lastRowFromOffset.setValue(copiedRowFromOffset.getValue());
      lastRowUntilOffset.setValue(copiedRowUntilOffset.getValue());

      event.preventDefault();
    });

    $('form').on('click', '.js-add-row', (event) => {
      const button = event.currentTarget;
      const tableId = button.dataset.table || 'recurrence_rulesTable';
      const table = document.getElementById(tableId);
      if (!table) return;

      const lastRow = table.querySelector('tr:last-of-type');

      const time = Date.now();
      const regexp = new RegExp(button.dataset.id, 'g');
      const newRowHTML = button.dataset.fields.replace(regexp, time);
      const newRow = document.createElement('tr');
      newRow.innerHTML = newRowHTML;

      const dayOfWeek = newRow.querySelector('.js-day-of-week');
      const validFromOffset = newRow.querySelector('.js-valid-from-offset');
      const validUntilOffset = newRow.querySelector('.js-valid-until-offset');

      if (dayOfWeek) setupTomSelect(dayOfWeek);
      if (validFromOffset) setupTomSelect(validFromOffset);
      if (validUntilOffset) setupTomSelect(validUntilOffset);

      lastRow.insertAdjacentElement('afterend', newRow);

      event.preventDefault();
    });

    $('form').on('click', '.js-add-row-for-fare-adapter-element', (event) => {
      const button = event.currentTarget;
      const tableId = button.dataset.table;
      const table = document.getElementById(tableId);
      if (!table) return;
      const tableBody = table.querySelector('tbody');

      const time = Date.now();
      const regexp = new RegExp(button.dataset.id, 'g');
      const newRowHTML = button.dataset.fields.replace(regexp, time);
      const newRow = document.createElement('tr');
      newRow.innerHTML = newRowHTML;

      newRow
        .querySelectorAll('select:not([data-no-tomselect]):not(.js-autocomplete-user-widget):not(.js-autocomplete-station-widget):not(.js-tagging)')
        .forEach((element) => setupTomSelect(element));

      syncFareAdapterElementRowState(newRow);

      if (tableBody) {
        tableBody.insertAdjacentElement('beforeend', newRow);
      } else {
        table.insertAdjacentElement('beforeend', newRow);
      }

      if (button.dataset.localizedFields && button.dataset.localizedContainer) {
        const localizedContainer = document.getElementById(button.dataset.localizedContainer);
        if (localizedContainer) {
          const localizedHTML = button.dataset.localizedFields.replace(/NEW_RECORD/g, time);
          const localizedWrapper = document.createElement('div');
          localizedWrapper.innerHTML = localizedHTML;
          localizedContainer.insertAdjacentElement('beforeend', localizedWrapper);
        }
      }

      event.preventDefault();
    });

    $('form').on('change', 'select[name*="[elements_attributes]"][name*="[price_type]"]', (event) => {
      const row = event.currentTarget.closest('tr');
      if (!row) return;

      if (event.currentTarget.value === 'base_price') {
        const discountTypeField = row.querySelector('select[name*="[elements_attributes]"][name*="[discount_type]"]');
        const relativeAmountField = row.querySelector('input[name*="[elements_attributes]"][name*="[relative_amount]"]');

        if (discountTypeField) {
          discountTypeField.value = '';
          if (discountTypeField.tomselect) {
            discountTypeField.tomselect.clear(true);
          }
        }

        if (relativeAmountField) {
          relativeAmountField.value = '';
        }
      }

      syncFareAdapterElementRowState(row);
    });

    $('form').on('change', 'select[name*="[elements_attributes]"][name*="[discount_type]"]', (event) => {
      const row = event.currentTarget.closest('tr');
      if (!row) return;

      const absoluteAmountField = row.querySelector('input[name*="[elements_attributes]"][name*="[absolute_amount]"]');
      const relativeAmountField = row.querySelector('input[name*="[elements_attributes]"][name*="[relative_amount]"]');

      if (event.currentTarget.value === 'relative' && absoluteAmountField) {
        absoluteAmountField.value = '';
      }

      if (event.currentTarget.value === 'absolute' && relativeAmountField) {
        relativeAmountField.value = '';
      }

      syncFareAdapterElementRowState(row);
    });
  });
};

export { setupTomSelect, setupTomSelectTagging, setupTomSelectAjax, setupRecurrenceRulesFormButtons };
